export const HighlightSetup = {
  projectId: process.env.NEXT_PUBLIC_HIGHLIGHT_PROJECT_ID,
  serviceName: `docsum-ui-${process.env.NEXT_PUBLIC_ENVIRONMENT}`,
}

export const isHighlightEnabled =
  process.env.NEXT_PUBLIC_ENABLE_HIGHLIGHT === 'true'
